export default __webpack_public_path__ + "static/media/snow-showers-night.91f63520.svg";